import { Box, Divider, Grid, Modal, Typography } from '@material-ui/core'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import ChatBubbleOutlineOutlinedIcon from '@material-ui/icons/ChatBubbleOutlineOutlined'
import CloseIcon from '@material-ui/icons/Close'
import { Link } from 'gatsby'
import { TFunction } from 'i18next'
import React, { useEffect, useState } from 'react'
import { isIOS, isMacOs } from 'react-device-detect'
import { withTranslation } from 'react-i18next'
import { Carousel } from 'react-responsive-carousel'
import 'react-responsive-carousel/lib/styles/carousel.min.css'
import {
  EmailShareButton,
  FacebookShareButton,
  PinterestShareButton,
  TwitterShareButton,
} from 'react-share'
import {
  generateTrackingLink,
  urlSafeProductName,
} from '../../../utils/brandsHelper'
import { errorToast } from '../../../utils/errToast'
import { TrackingCase } from '../../../utils/trackingCases'
import { trackAddToCart } from '../../../utils/metaPixel'
import { useAppState } from '../../appState'
import clipboard from '../../assets/images/clipboard.svg'
import emailIcon from '../../assets/images/dark-email.svg'
import facebookIcon from '../../assets/images/facebook.svg'
import heartFilled from '../../assets/images/heart_filled.svg'
import heart from '../../assets/images/heart_unfilled.svg'
import pinterest from '../../assets/images/pinterest.svg'
import twiterIcon from '../../assets/images/twitter.svg'
import axios from '../../axios'
import { BREAKPOINTS, CSEvents, ENDPOINTS } from '../../constants'
import useAdmin from '../../hooks/useAdmin'
import { useDigitalMarketerShopGate } from '../../hooks/useDigitalMarketerShopGate'
import { tracker } from '../../systemLogs'
import CreateProductShareLink from '../createProductShareLink'
import DigitalMarketerShopModal from '../digitalMarketerShopModal'
import SocialShareLink from '../SocialShareLink'
import SignInModal from './../signInModal'
import CHRImage from './CHRImage'
import { styles } from './styles'
import Anchor from '../anchor'

declare const window: any

interface CardProps {
  productInfo: {
    product_id: string
    thumbnail_url: string
    cashBack: string
    name: string
    brand_name: string
    brand_id: string
    network_id: number
    price: number
    original_price: number
    tracking_url: string
    product_url: string
    isAdded: boolean
    description: string
    images_urls: string[]
    shoppingBoardId: number
    trendingId?: number
    clicksCount?: number
    sold?: number
  }
  customText: string
  isCashbackShownInWebsite: boolean
  t: TFunction
  userId: number
  updateProducts: Function
  onRemove?: Function
  isTopItem: boolean
  shareable: boolean
  isPriceBottomOnMobile?: boolean
}

const Card = ({
  t,
  userId,
  updateProducts,
  onRemove,
  isTopItem,
  shareable,
  isPriceBottomOnMobile = false,
  isCashbackShownInWebsite = true,
  customText = 'cash back',
  productInfo: {
    product_id,
    thumbnail_url,
    cashBack,
    clicksCount,
    sold,
    name,
    brand_name,
    brand_id,
    price,
    original_price,
    tracking_url,
    product_url,
    isAdded,
    description,
    network_id,
    images_urls,
    shoppingBoardId,
    trendingId,
  },
}: CardProps) => {
  const [appState] = useAppState()
  const [isAdmin] = useAdmin()
  const {
    interceptAnchorClick,
    modalProps: digitalMarketerModalProps,
  } = useDigitalMarketerShopGate()
  const [open, setOpen] = useState(false)
  const isDesktop = useMediaQuery(`@media (min-width: ${BREAKPOINTS.lg}px)`)
  const [shortenedLink, setShortenedLink] = useState({
    value: '',
    commission: '',
    isLoading: false,
  })
  const [added, setAdded] = useState(Boolean(shoppingBoardId))
  const [loading, setLoading] = useState(false)
  const classes = styles()
  const [isOpenSignInModal, setIsOpenSignInModal] = useState(false)
  const [isLoggedIn, setIsLoggedIn] = useState(false)

  useEffect(() => {
    appState.userId && setIsLoggedIn(true)
  }, [])

  const getProdcutUrl = () => {
    let url = `/p/${urlSafeProductName(name, brand_name)}/${product_id}`
    if (trendingId) url += `?trending=${trendingId}`
    return url
  }

  const changeWindowUrl = (title: string, url: string) => {
    if (typeof history.pushState !== 'undefined') {
      const Title = title
      const Url = url

      history.pushState({ Title, Url }, Title, Url)
    }
  }

  const handleClose = () => {
    const productUrl = getProdcutUrl().split('?')[0]
    if (window.location.pathname === productUrl) {
      shareable && history.back()
    }

    setOpen(false)
    window.removeEventListener('popstate', handleClose)
  }

  const handleOpen = () => {
    trackClickStream(CSEvents.viewProduct)
    if (shareable) {
      window.addEventListener('popstate', handleClose)
      changeWindowUrl(location.pathname, getProdcutUrl())
    }
    setOpen(true)
    if (appState.username) {
      window.klaviyoTrigger('Product Viewed', product_id, name)
    }
  }

  const closeSignInModal = () => {
    setIsOpenSignInModal(false)
  }

  const trackingLink = generateTrackingLink(
    {
      network: network_id,
      trackingLink: tracking_url,
      url: product_url,
      brandName: brand_name,
      commission: cashBack,
    },
    {
      userId: `${userId || 0}`,
      userName: appState.userProfile?.userName,
    },
    product_id,
    '',
    Boolean(userId)
  )
  const trackingLinkNoRedirect = generateTrackingLink(
    {
      network: network_id,
      trackingLink: tracking_url,
      url: product_url,
      brandName: brand_name,
      commission: cashBack,
    },
    {
      userId: `${userId || 0}`,
      userName: appState.userProfile?.userName,
    },
    product_id,
    '',
    false
  )

  const handleAddToShoppingBoard = async () => {
    if (!isLoggedIn) {
      setIsOpenSignInModal(true)
      handleClose()
      return
    }
    setAdded(true)
    setLoading(true)
    tracker.track(
      TrackingCase.UserTracking,
      `POST ${ENDPOINTS.addToShoppingBoard}`,
      { location: 'Card', barndId: brand_id, productId: product_id }
    )
    trackClickStream(CSEvents.addProductToBoard)
    const res = await axios.post(ENDPOINTS.addToShoppingBoard, {
      brandId: brand_id,
      type: 'product',
      productId: product_id,
      data: {
        name,
        imageUrl: thumbnail_url,
        price:
          isNaN(price) || String(price) === ''
            ? `${price}`
            : '$' + price.toFixed(2),
        originalPrice:
          isNaN(original_price) || String(original_price) === ''
            ? `${original_price}`
            : '$' + original_price.toFixed(2),
        brandId: brand_id,
        brandName: brand_name,
        networkId: network_id,
        link: product_url,
        tracking_url: tracking_url,
      },
    })
    setLoading(false)
    updateProducts(product_id || trendingId, res.data.data.id)
    if (appState.username) {
      window.itemsFavourite(
        name.replace(/"/g, ''),
        {
          name: name.replace(/"/g, ''),
          imageUrl: thumbnail_url,
          price,
          brandId: brand_id,
          brandName: brand_name,
          networkId: network_id,
          link: product_url,
          tracking_url: tracking_url,
        },
        (price + '').replace(/\$/g, '')
      )
    }
  }
  const handleRemoveFromShoppingBoard = async () => {
    setAdded(false)
    setLoading(true)
    tracker.track(
      TrackingCase.UserTracking,
      `DELETE ${ENDPOINTS.deleteShoppingBoardItem}`,
      { location: 'Card', SBoardId: shoppingBoardId }
    )
    trackClickStream(CSEvents.removeProductFromBoard)
    await axios.delete(
      ENDPOINTS.deleteShoppingBoardItem.replace(':id', shoppingBoardId)
    )
    setLoading(false)
  }

  const handleSMSButtonClick = () => {
    if (isIOS || isMacOs) {
      window.open(
        `sms:?&body=${t('createLink.smsMessage') + shortenedLink.value}`,
        '_self'
      )
    } else {
      window.open(
        `sms:?body=${t('createLink.smsMessage') + shortenedLink.value}`,
        '_self'
      )
    }
  }

  const toggleAddingToShoppingBoard = async () => {
    try {
      if (added) {
        await handleRemoveFromShoppingBoard()
      } else {
        await handleAddToShoppingBoard()
      }
    } catch (err) {
      setTimeout(() => {
        setLoading(false)
        setAdded(s => !s)
      }, 500)
    }
  }

  const deleteProduct = async () => {
    tracker.track(
      TrackingCase.UserTracking,
      `POST ${ENDPOINTS.deleteProduct}`,
      { location: 'Card', networkId: network_id, productId: product_id }
    )
    try {
      const res = await axios.post(ENDPOINTS.deleteProduct, {
        productId: product_id,
        networkId: network_id,
      })
      if (res.data.data.success) onRemove && onRemove(product_id)
    } catch (err) {
      errorToast(`couldn't remove item, please try again`)
    }
  }

  const onAddToShoppingBoardClick = async () => {
    try {
      await handleAddToShoppingBoard()
    } catch (err) {
      setTimeout(() => setAdded(false), 500)
    }
  }

  const truncate = (text: string = '') => {
    if (text.length > 250) {
      return text.slice(0, 250) + '...'
    }
    return name
  }

  const deviceType = () => {
    const ua = navigator.userAgent
    if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
      return 'tablet'
    } else if (
      /Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
        ua
      )
    ) {
      return 'mobile'
    }
    return 'desktop'
  }

  const trackClickStream = (event: string, params = {}) => {
    tracker.trackCs(event, {
      pageUrl: window.location.href,
      productId: product_id,
      brandId: brand_id,
      section: window.location.href.includes('category')
        ? 'shop-by-category'
        : window.location.href.includes('featured-brands')
        ? 'featured-brands'
        : 'member-home-trending',
      ...params,
    })
    if (event === CSEvents.clickProduct) {
      trackAddToCart({ productId: product_id, name, price })
    }
  }

  const handleShopAnchorClick = interceptAnchorClick(product_url, () =>
    trackClickStream(CSEvents.clickProduct)
  )

  return (
    <div className={classes.container}>
      <div className={classes.imageContainer}>
        {isDesktop ? (
          <CHRImage
            src={thumbnail_url}
            alt={name}
            className={classes.image}
            onClick={handleOpen}
          />
        ) : (
          <Anchor
            href={trackingLink}
            className={classes.anchorWidth}
            onClick={handleShopAnchorClick}
          >
            <CHRImage
              src={thumbnail_url}
              alt={name}
              className={classes.image}
            />
          </Anchor>
        )}
        {!isTopItem && (
          <>
            <button
              disabled={loading}
              onClick={toggleAddingToShoppingBoard}
              className={classes.heart}
            >
              <img
                src={added ? heartFilled : heart}
                alt="heart-icon"
                width="22"
                height="20"
              />
            </button>
            {isAdmin && onRemove && (
              <button
                disabled={loading}
                onClick={deleteProduct}
                className={classes.deleteIcon}
              >
                <CloseIcon />
              </button>
            )}
          </>
        )}
        {isDesktop && (
          <>
            <Anchor
              className={classes.shopButton}
              href={trackingLink}
              onClick={handleShopAnchorClick}
            >
              {t('shared.shop')}
            </Anchor>
            <Modal
              open={open}
              onClose={handleClose}
              aria-labelledby="simple-modal-trending"
              aria-describedby="simple-modal-description"
            >
              <div className={classes.paper}>
                <div className={classes.closeButton} onClick={handleClose}>
                  <CloseIcon />
                </div>
                <Grid container flex alignItems="center">
                  <Grid item lg={6}>
                    <Carousel
                      swipeable={true}
                      showArrows={false}
                      showThumbs={false}
                      emulateTouch={true}
                      showStatus={false}
                    >
                      {[thumbnail_url]
                        .concat(images_urls)
                        .map((image, index) => {
                          return (
                            <div key={index} style={{ height: '100%' }}>
                              <CHRImage
                                src={image}
                                alt={name}
                                draggable={false}
                                errStyle={classes.errImage}
                                className={classes.productImage}
                                style={{ pointerEvents: 'all' }}
                              />
                            </div>
                          )
                        })}
                    </Carousel>
                  </Grid>
                  <Grid item lg={6} className={classes.modalInfo}>
                    <Typography variant="h3" className={classes.modalInfoTitle}>
                      {name}
                    </Typography>
                    <Grid container>
                      <Grid item lg={8}>
                        <Typography variant="h3">
                          {t('shared.from')}{' '}
                          <Link
                            to={`/featured-brands/${brand_name.replace(
                              /\s+|\/|\\|#/g,
                              '-'
                            )}/${brand_id}`}
                            className={classes.brandLink}
                          >
                            {brand_name}
                          </Link>
                        </Typography>
                      </Grid>
                      <Grid item lg={4}>
                        <Typography
                          variant="h3"
                          className={classes.modalInfoPrice}
                        >
                          {isNaN(price) || String(price) === ''
                            ? `${price}`
                            : '$' + price.toFixed(2)}
                        </Typography>
                      </Grid>
                    </Grid>
                    <Divider />
                    <Typography
                      variant="subtitle1"
                      className={classes.modalInfoDescription}
                    >
                      {truncate(description)}
                    </Typography>
                    <Anchor
                      className={`${classes.modalButton} ${classes.blackBgButton}`}
                      href={trackingLink}
                      onClick={handleShopAnchorClick}
                    >
                      <Typography variant="button">
                        {t('shared.shop')}
                      </Typography>
                    </Anchor>
                    <Divider />
                    <Box mt={1} />
                    <CreateProductShareLink
                      networkId={network_id}
                      productId={product_id}
                      productUrl={product_url}
                      productName={name}
                      productImage={thumbnail_url}
                      shortenedLink={shortenedLink}
                      setShortenedLink={s => {
                        setShortenedLink(s)
                        if (s.value) {
                          trackClickStream(CSEvents.shareProduct, {
                            shareType: 'link',
                          })
                        }
                      }}
                      isLoggedIn={isLoggedIn}
                      handleOpenModal={() => setIsOpenSignInModal(true)}
                    />
                    <button
                      className={`${classes.modalButton} ${classes.whiteBgButton} ${classes.addToShoppingBoard}`}
                      onClick={onAddToShoppingBoardClick}
                      disabled={added}
                    >
                      <div className={classes.addToboardContainer}>
                        <img src={clipboard} alt={t('createLink.clipboard')} />
                        <Typography
                          variant="button"
                          className={classes.addToboardText}
                        >
                          {added
                            ? t('createLink.addedToBoard')
                            : t('createLink.addToboard')}
                        </Typography>
                      </div>
                    </button>
                    <Typography
                      variant="subtitle1"
                      className={classes.socialTitle}
                    >
                      {t('shared.orShareVia')}
                    </Typography>

                    {/*   ----   social links  ---   */}
                    <Grid container justifyContent="center" alignItems="center">
                      <div className={classes.socialButton}>
                        <SocialShareLink
                          onInitial={() =>
                            setShortenedLink({
                              value: '',
                              commission: '',
                              isLoading: true,
                            })
                          }
                          onSuccess={data => {
                            trackClickStream(CSEvents.shareProduct, {
                              shareType: 'email',
                            })
                            setShortenedLink({
                              value: data.shortUrl,
                              commission: data.commission,
                              isLoading: false,
                            })
                          }}
                          onFail={() => setIsOpenSignInModal(true)}
                          shortenedLink={shortenedLink.value}
                          shortLinkData={{
                            url: product_url,
                            productId: product_id,
                            productName: name,
                            productImage: thumbnail_url,
                          }}
                          isLoggedIn={isLoggedIn}
                        >
                          {(ref, url) => (
                            <>
                              <EmailShareButton
                                ref={ref}
                                subject={t('createLink.emailSubject')}
                                body={t('createLink.emailBody')}
                                url={url}
                                style={{
                                  display: 'none',
                                }}
                              >
                                <img
                                  src={emailIcon}
                                  alt={t('shared.email')}
                                  className={classes.socialIcon}
                                />
                              </EmailShareButton>
                              <img
                                src={emailIcon}
                                alt={t('shared.email')}
                                className={classes.socialIcon}
                              />
                            </>
                          )}
                        </SocialShareLink>
                      </div>

                      <div className={classes.socialButton}>
                        <SocialShareLink
                          onInitial={() =>
                            setShortenedLink({
                              value: '',
                              commission: '',
                              isLoading: true,
                            })
                          }
                          onSuccess={data => {
                            trackClickStream(CSEvents.shareProduct, {
                              shareType: 'sms',
                            })
                            setShortenedLink({
                              value: data.shortUrl,
                              commission: data.commission,
                              isLoading: false,
                            })
                          }}
                          onFail={() => setIsOpenSignInModal(true)}
                          shortenedLink={shortenedLink.value}
                          shortLinkData={{
                            url: product_url,
                            productId: product_id,
                            productName: name,
                            productImage: thumbnail_url,
                          }}
                          isLoggedIn={isLoggedIn}
                        >
                          {ref => (
                            <>
                              <div
                                ref={ref}
                                style={{
                                  display: 'none',
                                }}
                                onClick={handleSMSButtonClick}
                              >
                                <ChatBubbleOutlineOutlinedIcon />
                              </div>
                              <ChatBubbleOutlineOutlinedIcon />
                            </>
                          )}
                        </SocialShareLink>
                      </div>

                      <div className={classes.socialButton}>
                        <SocialShareLink
                          onInitial={() =>
                            setShortenedLink({
                              value: '',
                              commission: '',
                              isLoading: true,
                            })
                          }
                          onSuccess={data => {
                            trackClickStream(CSEvents.shareProduct, {
                              shareType: 'facebook',
                            })
                            setShortenedLink({
                              value: data.shortUrl,
                              commission: data.commission,
                              isLoading: false,
                            })
                          }}
                          onFail={() => setIsOpenSignInModal(true)}
                          shortenedLink={shortenedLink.value}
                          shortLinkData={{
                            url: product_url,
                            productId: product_id,
                            productName: name,
                            productImage: thumbnail_url,
                          }}
                          isLoggedIn={isLoggedIn}
                        >
                          {(ref, url) => (
                            <>
                              <FacebookShareButton
                                ref={ref}
                                url={url}
                                quote={t('createLink.socialMessage')}
                                style={{
                                  display: 'none',
                                }}
                              >
                                <img
                                  src={facebookIcon}
                                  alt={t('imageAlts.facebook')}
                                  className={classes.socialIcon}
                                />
                              </FacebookShareButton>
                              <img
                                src={facebookIcon}
                                alt={t('imageAlts.facebook')}
                                className={classes.socialIcon}
                              />
                            </>
                          )}
                        </SocialShareLink>
                      </div>

                      <div className={classes.socialButton}>
                        <SocialShareLink
                          onInitial={() =>
                            setShortenedLink({
                              value: '',
                              commission: '',
                              isLoading: true,
                            })
                          }
                          onSuccess={data => {
                            trackClickStream(CSEvents.shareProduct, {
                              shareType: 'twitter',
                            })
                            setShortenedLink({
                              value: data.shortUrl,
                              commission: data.commission,
                              isLoading: false,
                            })
                          }}
                          onFail={() => setIsOpenSignInModal(true)}
                          shortenedLink={shortenedLink.value}
                          shortLinkData={{
                            url: product_url,
                            productId: product_id,
                            productName: name,
                            productImage: thumbnail_url,
                          }}
                          isLoggedIn={isLoggedIn}
                        >
                          {(ref, url) => (
                            <>
                              <TwitterShareButton
                                ref={ref}
                                url={url}
                                title={t('createLink.socialMessage')}
                                style={{
                                  display: 'none',
                                }}
                              >
                                <img
                                  src={twiterIcon}
                                  alt={t('imageAlts.twitter')}
                                  className={classes.socialIcon}
                                />
                              </TwitterShareButton>
                              <img
                                src={twiterIcon}
                                alt={t('imageAlts.twitter')}
                                className={classes.socialIcon}
                              />
                            </>
                          )}
                        </SocialShareLink>
                      </div>

                      <div className={classes.socialButton}>
                        <SocialShareLink
                          onInitial={() =>
                            setShortenedLink({
                              value: '',
                              commission: '',
                              isLoading: true,
                            })
                          }
                          onSuccess={data => {
                            trackClickStream(CSEvents.shareProduct, {
                              shareType: 'pinterest',
                            })
                            setShortenedLink({
                              value: data.shortUrl,
                              commission: data.commission,
                              isLoading: false,
                            })
                          }}
                          onFail={() => setIsOpenSignInModal(true)}
                          shortenedLink={shortenedLink.value}
                          shortLinkData={{
                            url: product_url,
                            productId: product_id,
                            productName: name,
                            productImage: thumbnail_url,
                          }}
                          isLoggedIn={isLoggedIn}
                        >
                          {(ref, url) => (
                            <>
                              <PinterestShareButton
                                ref={ref}
                                url={trackingLinkNoRedirect}
                                description={t('createLink.socialMessage')}
                                media={thumbnail_url}
                                style={{
                                  display: 'none',
                                }}
                              >
                                <img
                                  src={pinterest}
                                  alt={t('imageAlts.pinterest')}
                                  className={classes.socialIcon}
                                />
                              </PinterestShareButton>
                              <img
                                src={pinterest}
                                alt={t('imageAlts.pinterest')}
                                className={classes.socialIcon}
                              />
                            </>
                          )}
                        </SocialShareLink>
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
              </div>
            </Modal>
          </>
        )}
        {isTopItem && (
          <Typography
            component="p"
            className={`${classes.topItemCashBack} ${classes.productInfo}`}
          >
            <span
              style={{
                width: '33%',
                display: 'inline-block',
                marginTop: '0.75rem',
                marginBottom: '0.75rem',
              }}
            >
              {`${clicksCount || 0} CLICKS`}
            </span>
            <span
              style={{
                width: '33%',
                display: 'flex',
                margin: '0 auto',
                justifyContent: 'center',
                alignItems: 'center',
                background: 'white',
              }}
            >
              {`${sold} SOLD`}
            </span>
            <span
              style={{
                width: '33%',
                display: 'inline-block',
                marginTop: '0.75rem',
                marginBottom: '0.75rem',
              }}
            >
              {`EARNED $${cashBack || 0}`}
            </span>
          </Typography>
        )}
        {!isTopItem && (
          <Typography
            component="p"
            className={`${classes.cashBack} ${classes.productInfo}`}
          >
            {isCashbackShownInWebsite && cashBack !== ''
              ? `up to ${cashBack} ${customText}`
              : 'shop now'}
          </Typography>
        )}
      </div>
      <div className={classes.nameAndPrice}>
        <Typography
          component="h2"
          className={`${classes.productName} ${classes.productInfo}`}
        >
          {product_id ? (
            <Link
              style={{
                textDecoration: 'none',
                color: 'inherit',
              }}
              to={getProdcutUrl()}
            >
              {name}
            </Link>
          ) : (
            <Anchor
              style={{
                textDecoration: 'none',
                color: 'inherit',
              }}
              href={trackingLink}
              onClick={handleShopAnchorClick}
            >
              {name}
            </Anchor>
          )}
        </Typography>

        {!(deviceType() === 'mobile' && isPriceBottomOnMobile) && (
          <>
            {price < original_price ? (
              <div>
                <Typography component="p" className={` ${classes.productInfo}`}>
                  ${price.toFixed(2)}
                </Typography>
                <Typography
                  component="p"
                  className={`${classes.lineThrough} ${classes.productInfo}`}
                >
                  ${original_price.toFixed(2)}
                </Typography>
                <Typography
                  component="p"
                  className={`${classes.salePrice} ${classes.productInfo}`}
                >
                  {isNaN(price) || String(price) === ''
                    ? `${price}`
                    : '$' + price.toFixed(2)}
                </Typography>
              </div>
            ) : (
              <Typography component="p" className={classes.productInfo}>
                {isNaN(price) || String(price) === ''
                  ? `${price}`
                  : '$' + price.toFixed(2)}
              </Typography>
            )}
          </>
        )}
      </div>

      <Typography
        variant="subtitle1"
        component="p"
        className={classes.retailerName}
      >
        {brand_name}
      </Typography>

      {deviceType() === 'mobile' && isPriceBottomOnMobile && (
        <>
          {price < original_price ? (
            <div className={classes.flex}>
              <Typography component="p" className={` ${classes.productInfo}`}>
                ${price.toFixed(2)}
              </Typography>
              <Typography
                component="p"
                className={`${classes.lineThrough} ${classes.productInfo}`}
              >
                ${original_price.toFixed(2)}
              </Typography>
              <Typography component="p" className={`${classes.productInfo}`}>
                {isNaN(price) || String(price) === ''
                  ? `${price}`
                  : '$' + price.toFixed(2)}
              </Typography>
            </div>
          ) : (
            <div className={classes.flex}>
              <Typography component="p" className={classes.productInfo}>
                {isNaN(price) || String(price) === ''
                  ? `${price}`
                  : '$' + price.toFixed(2)}
              </Typography>
            </div>
          )}
        </>
      )}

      <SignInModal
        handleClose={closeSignInModal}
        openStatus={isOpenSignInModal}
        setIsLoggedIn={setIsLoggedIn}
      />

      <DigitalMarketerShopModal {...digitalMarketerModalProps} />
    </div>
  )
}

export default withTranslation()(Card)
